import { a as i, j as t } from "../../../jsx-runtime-c20f6c15.mjs";
import s from "clsx";
import a from "../../../shared/illustrations/brush-stroke-1.svg.mjs";
import c from "../Button/Button.mjs";
import "react";
import "../Spinner/Spinner.mjs";
const m = "_container_1btue_1", l = {
  container: m
};
function j({
  text: r,
  active: o = !1,
  onClick: n,
  className: e
}) {
  return /* @__PURE__ */ i("div", { className: s(l.container, e), children: [
    o && /* @__PURE__ */ t(a, {}),
    /* @__PURE__ */ t(c, { plain: !0, onClick: n, children: r })
  ] });
}
export {
  j as default
};
